import { newrelic } from 'lib/newrelic'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, retryKey: 0 }
    this.retryTimeout = null
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error, { componentStack }) {
    let boundaryError = new Error(error.message)
    boundaryError.name = `React ErrorBoundary ${boundaryError.name}`
    boundaryError.stack = componentStack

    error.cause = boundaryError

    newrelic?.noticeError(error)

    if (this.props.autoRetryDelay) {
      this.retryTimeout = setTimeout(() => {
        this.setState((state) => ({ hasError: false, retryKey: state.retryKey + 1 }))
      }, this.props.autoRetryDelay)
    }
  }

  componentWillUnmount() {
    if (this.retryTimeout) {
      clearTimeout(this.retryTimeout)
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <p>
          An error has occurred. Please try again, and if you continue to encounter the
          same issue, report this to support.
        </p>
      )
    }

    return <React.Fragment key={this.state.retryKey}>{this.props.children}</React.Fragment>
  }
}
